
import {FC} from 'react'
import {Link} from 'react-router-dom'
import { IProject } from '../core/_models'
import Status from '../../apps/components/Status'
import { IconUserModel } from '../../core/_models'
import { getProjectStageLink } from '../../../../utils/config'


type Props = {
  project:IProject
}

const allowedStatuses = ['In Progress', 'Completed'] as const
type AllowedStatus = typeof allowedStatuses[number]

const ProjectCard: FC<Props> = ({
  project
}) => {
    const status = project.current_stage_status as AllowedStatus
    return (
        <Link
        to={getProjectStageLink(project.project_id)}
        className='card border border-2 border-gray-300 h-100'
        >
        <div className='card-header border-0 p-0 overflow-hidden'>
            <img src={'/media/images/grid-img-1.jpg'} alt='card2' className='p-0 w-100' />

            <div className='card-toolbar m-0 position-absolute end-0 top-0'>
                <span className="badge badge-warning fw-bold me-auto px-4 py-3">{project.sector_name}</span>
            </div>
        </div>

        <div className='card-body p-5'>
            <div className='fs-4 fw-bold text-gray-900  mb-5' style={{whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}}>{project.name}</div>
            {project.current_stage && 
            
            <div className='d-flex flex-column border border-gray-300 border-dashed rounded py-3 px-4 me-7 mb-3'>
                <div className='fs-6 text-gray-500 fw-bold'>{project.current_stage}</div>
                <div className='text-gray-500 fw-bold'>
                    {allowedStatuses.includes(project.current_stage_status as AllowedStatus) ? (
                        <Status status={status} className='fs-9'  />
                    ) : (
                        <span className="badge badge-light-secondary fs-9">{project.current_stage_status}</span>
                    )}
                </div>   
            </div> }
            <div className='d-flex border border-gray-300 border-dashed rounded py-3 px-4 me-7 mb-3'>
                <div className='fs-6 text-gray-500 fw-bold'>{project.department_name}</div>
            </div>
        </div>
        </Link>
    )
}

export {ProjectCard}
